export default __webpack_public_path__ + "static/media/3-4-1.7ce6de2b.jpg";